import fetch from '@/utils/fetch';

import { MerchantListSearchParams } from './type';
import { PAGE_SIZE } from './constants';
import { message } from 'antd';
import filterNull from '@/utils/filterNull';

const model = {
  state: {
    merchantSearchParams: { page: 1, pageSize: PAGE_SIZE },
    merchantData: {},
    baseAccountInfo: {},
    merchantAuditCount: {
      firstAuditCount: 0,
      secondAuditCount: 0,
      passedUpdateCount: 0,
    },
    saasContractInfo: null, // saas代理商合同信息
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { merchant, basic }, getState }: any) => ({
    async getMerchantList(params: MerchantListSearchParams) {
      const merchantSearchParams = {
        ...getState().merchant.merchantSearchParams,
        ...(params || {}),
      };
      const res = await fetch('/saasmerchant/web/bms/merchant/list', {
        params: filterNull(merchantSearchParams),
        type: 'POST',
        useJson: true,
      });

      merchant.setState({ merchantSearchParams, merchantData: res || {} });
    },
    // 商户列表订单导出
    async exportOrderInfo(params) {
      const data = await fetch('/saasmerchant/web/bms/merchant/export/orderSettlementInfo', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('导出成功');
        basic.setLogListDot(true);
      }
    },
    // 商户列表物流导出
    async exportLogisticsInfo(params) {
      const data = await fetch('/saasmerchant/web/bms/merchant/export/shopLogisticsInfo', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('导出成功');
        basic.setLogListDot(true);
      }
    },
    async getMerchantBaseInfo(id: string) {
      const res = await fetch('/saasmerchant/web/bms/merchant/getBasicInfo', {
        params: { merchantId: id },
      });
      res.cateringMode = res.cateringMode === 0 ? null : res.cateringMode;
      return res;
    },
    async updateMerchantPassword(id: string) {
      const res = await fetch('/saasmerchant/web/bms/merchant/resetPassword', {
        params: { merchantId: id },
      });
      return res;
    },
    async saveMerchantDetailInfo(params: any) {
      return fetch('/saasmerchant/web/bms/merchant/detailsSubmit', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async getMerchantDetailInfo(params: any) {
      const res = await fetch('/saasmerchant/web/bms/merchant/getDetails', {
        params,
      });
      return res;
    },
    async handleConfirmPreAudit(params: any) {
      return fetch('/saasmerchant/web/bms/merchant/verify', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async changeSaleMan(params: any) {
      return fetch('/saasmerchant/web/bms/merchant/changeSeller', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async createContractInfo(params: any) {
      return fetch('/saasmerchant/web/bms/shop/newContract/saveContract', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async editContractInfo(params: any) {
      return fetch('/saasmerchant/web/bms/shop/newContract/updateContract', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async reAuditSubmit(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/updateAndToAudit', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async reAudit(params: any) {
      return fetch('/saasmerchant/web/bms/shop/newContract/auditContract', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async getContractList(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/list', {
        params,
        type: 'POST',
        useJson: true,
      });
    },
    async getContractDetail(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/detail', {
        params,
        useJson: true,
      });
    },
    async getNewContractDetail(params: any) {
      return fetch('/saasmerchant/web/bms/shop/newContract/detail', {
        params,
        useJson: true,
      });
    },
    async getContractLogList(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/log/list', {
        params,
      });
    },
    async getDeliveryPriceList(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/fslogistics/valuationquery', {
        params,
        type: 'POST',
        useJson: true,
      });
    },
    async saveDeliveryPriceRule(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/fslogistics/valuationcu', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async changeDeliveryPriceRuleStatus(params: any) {
      return fetch('/saasmerchant/web/fslogistics/valuationstatusupdate', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async editAudit(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/auditUpdate', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async getRelationShops(shopId: string) {
      return fetch('/saasmerchant/web/bms/shop/contract/fslogistics/subshoplist', {
        params: { shopId },
      });
    },
    async stopContract(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/suspend', {
        params,
        type: 'POST',
        useJson: true,
      });
    },
    async setThirdPlat(params: any) {
      return fetch('/merchant/tp/settpserviceconf', {
        params,
        type: 'POST',
      });
    },
    async getContractDiffData(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/log/getDifferenceOfContractLogToAudit', {
        params,
      });
    },
    async setThirdPosConfig(params: any) {
      return fetch('/saasmerchant/web/crm/merchant/setposconf', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async getTsSwitchSetting(params: any) {
      return fetch('/saasmerchant/web/crm/merchant/getTsSwitch', {
        params,
      });
    },
    async setBusinessSwitch(params: any) {
      return fetch('/saasmerchant/web/crm/merchant/setTsSwitch', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async getSettleSubShops(params: any) {
      return fetch('/saasmerchant/web/bms/shop/contract/settlement/subShopList', { params });
    },
    async getBaseAccountInfo() {
      const res = await fetch('/saasmerchant/web/bms/getAccountInfo');
      merchant.setState({
        baseAccountInfo: res || {},
      });
      return res;
    },
    // 商户导出
    async exportMerchantInfo(params: any) {
      const data = await fetch('/saasmerchant/web/bms/merchant/export/merchantList', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('导出成功');
        basic.setLogListDot(true);
      }
    },
    // 获取核心产品下拉数据
    async getProductionList() {
      const res = await fetch('/saasmerchant/web/bms/business/shop/productionList');
      return res;
    },

    // 商户取消订单设置
    async setCloseOrderStatus(params: any) {
      const data = fetch('/saasmerchant/web/bms/merchant/setCloseOrderStatus', {
        params,
        type: 'GET',
      });
      return data;
    },

    // 获取商户截单设置
    async getCloseOrderStatus(params) {
      const data = await fetch('/saasmerchant/web/bms/merchant/getCloseOrderStatus', {
        type: 'GET',
        params,
      });
      return data;
    },
    async getContractDetailHistory(params: any) {
      return fetch('/saasmerchant/web/bms/shop/newContract/history/detail', {
        params,
        useJson: true,
      });
    },
    setSaasContractInfo(data) {
      merchant.setState({ saasContractInfo: data });
    },
  }),
};

export default model;
